import NAME from "./constants";

export const RESET_STATE = NAME + "/RESET_STATE";

export const GET = NAME + "/GET";
export const GET_REJECTED = NAME + "/GET_REJECTED";
export const GET_FULFILLED = NAME + "/GET_FULFILLED";

export const GET_INTERVIEW_FEEDBACK = NAME + "/GET_INTERVIEW_FEEDBACK";
export const GET_INTERVIEW_FEEDBACK_REJECTED = NAME + "/GET_INTERVIEW_FEEDBACK_REJECTED";
export const GET_INTERVIEW_FEEDBACK_FULFILLED = NAME + "/GET_INTERVIEW_FEEDBACK_FULFILLED";

export const PREVIEW_INTERVIEW_FEEDBACK = NAME + "/PREVIEW_INTERVIEW_FEEDBACK";
export const PREVIEW_INTERVIEW_FEEDBACK_REJECTED = NAME + "/PREVIEW_INTERVIEW_FEEDBACK_REJECTED";
export const PREVIEW_INTERVIEW_FEEDBACK_FULFILLED = NAME + "/PREVIEW_INTERVIEW_FEEDBACK_FULFILLED";